import React, { createContext, useContext, useState, useEffect } from 'react';
import baseURL from '../../url'; 

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
    const [usuario, setUsuario] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUsuario = async () => {
        try {
            const response = await fetch(`${baseURL}/userLogued.php`, {
                method: 'GET',
                credentials: 'include'
            });
            if (!response.ok) {
                throw new Error('Error en la respuesta de la red');
            }
            const data = await response.json();
            
            if (data && data.idUsuario) {
                setUsuario(data);
            } else if (data && data.usuario && data.usuario.idUsuario) {
                setUsuario(data.usuario);
            } else {
                setUsuario(null);
            }
        } catch (error) {
            console.error('Error al obtener datos:', error);
            setUsuario(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsuario();
    }, []);

    const loginUser = (datosUsuario) => {
        setUsuario(datosUsuario);
    };

    // Función para cerrar sesión en PHP y limpiar el estado de React
    const logoutUser = async () => {
        try {
            await fetch(`${baseURL}/logout.php`, {
                method: 'POST',
                credentials: 'include' // OBLIGATORIO para enviar la cookie PHPSESSID y destruirla
            });
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
        } finally {
            setUsuario(null); // Limpia el usuario en React
        }
    };

    return (
        <UserContext.Provider value={{ usuario, loading, fetchUsuario, loginUser, logoutUser }}>
            {children}
        </UserContext.Provider>
    );
};